/**
 * SizilPro — clientStore
 * Zustand store for the active client's metadata.
 * clientId lives in authStore; this store holds the client row itself.
 */

import { create } from "zustand";
import { supabase } from "@/lib/supabase";

export interface Client {
  id:         string;
  name:       string;
  slug:       string;
  industry:   string | null;
  status:     string;
  created_at: string;
}

interface ClientState {
  client:      Client | null;
  isLoading:   boolean;
  fetchClient: (clientId: string) => Promise<void>;
  clearClient: () => void;
}

export const useClientStore = create<ClientState>((set) => ({
  client:    null,
  isLoading: false,

  fetchClient: async (clientId) => {
    set({ isLoading: true });
    const { data, error } = await supabase
      .from("clients")
      .select("*")
      .eq("id", clientId)
      .single();

    if (error || !data) {
      console.warn("[clientStore] fetchClient failed:", error?.message);
      set({ isLoading: false });
      return;
    }
    set({ client: data as Client, isLoading: false });
  },

  clearClient: () => set({ client: null }),
}));
